import { ReactNode } from "react";

interface ProgressBarProps {
  title: string;
  progress: number;
  maxProgress: number;
  progressLabel?: string;
  icon?: ReactNode;
}

const ProgressBar = ({
  title, progress, maxProgress, progressLabel, icon,
}: ProgressBarProps) => {
  const progressPercentage = Math.min(Math.round(((progress || 0) / (maxProgress || 100)) * 100), 100);

  return (
    <div className="w-[239px] space-y-2">
      <div className="flex w-full items-center justify-between text-text-base typography-medium-strong">
        <div className="flex items-center gap-2">
          {icon && <div className="text-icon-bg-base">{icon}</div>}
          <span>{title}</span>
        </div>
        <div className="flex items-center">
          {progressLabel && <span className="pr-px">{progressLabel}</span>}
          <span className="typography-small-base">{`${progressPercentage}%`}</span>
        </div>
      </div>
      <div className="h-1 w-full rounded-full bg-bg-subtle">
        <div
          className="h-full rounded-full bg-bg-interactive-base"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
